export enum SourceType {
  Extension = 'extension',
  Platform = 'platform',
  Website = 'website',
  ExtensionPopup = 'extensionPopUp',
}

export enum VersionStatus {
  Active = 'active',
  Deprecated = 'deprecated',
}

export enum VersionErrorCode {
  DEPRECATED_VERSION = 'DEPRECATED_VERSION',
}
